<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
  >
    <path
      id="路径_135"
      data-name="路径 135"
      d="M15,30A15,15,0,1,1,30,15,15.044,15.044,0,0,1,15,30ZM15,1.667A13.482,13.482,0,0,0,1.667,15,13.482,13.482,0,0,0,15,28.333,13.482,13.482,0,0,0,28.333,15,13.482,13.482,0,0,0,15,1.667ZM20.5,20a.833.833,0,0,1-1.333,0L10,10.833c-.333-.333-.667-.75-.333-1.167a1.014,1.014,0,0,1,1.333,0L20.333,19C20.583,19.25,20.75,19.75,20.5,20Zm-.167-9L11,20.333a.946.946,0,0,1-.667.25C9.5,20.5,9.667,19.5,10,19.167L19.167,10c.333-.333.75-.667,1.167-.333A1.012,1.012,0,0,1,20.333,11Z"
      fill="red"
    />
  </svg>
</template>
